/**
 * Created by vladislav on 04/04/2023
 */

// Same as cc.BezierTo but without the "easing" effect
cc.QuadraticBezierTo = function (duration, config) {
    cc.ActionInterval.prototype.constructor.call(this);

    this._config = [];
    this._startPosition = cc.p(0, 0);
    this._previousPosition = cc.p(0, 0);

    if (config !== undefined) {
        this.initWithDuration(duration, config);
    }
};

cc.QuadraticBezierTo.prototype = Object.assign(Object.create(cc.ActionInterval.prototype), {
    constructor: cc.QuadraticBezierTo,

    initWithDuration: function (t, c) {
        if (cc.ActionInterval.prototype.initWithDuration.call(this, t)) {
            this._config = c;
            return true;
        }
        return false;
    },

    startWithTarget: function (target) {
        cc.ActionInterval.prototype.startWithTarget.call(this, target);
        this._previousPosition.x = target.x;
        this._previousPosition.y = target.y;
        this._startPosition.x = target.x;
        this._startPosition.y = target.y;

        this._config[0] = cc.pSub(this._config[0], this._startPosition);
        this._config[1] = cc.pSub(this._config[1], this._startPosition);
        this._config[2] = cc.pSub(this._config[2], this._startPosition);
    },

    bezierAt: function (p0, p1, p2, t) {
        const q = Math.pow(1 - t, 2);
        const p = 2 * (1 - t) * t;
        const r = Math.pow(t, 2);

        return p0 * q + p1 * p + p2 * r;
    },

    update: function (dt) {
        dt = this._computeEaseTime(dt);
        if (this.target) {
            let x = this.bezierAt(this._config[0].x, this._config[1].x, this._config[2].x, dt);
            let y = this.bezierAt(this._config[0].y, this._config[1].y, this._config[2].y, dt);

            const locStartPosition = this._startPosition;
            if (cc.ENABLE_STACKABLE_ACTIONS) {
                const targetX = this.target.getPositionX();
                const targetY = this.target.getPositionY();
                const locPreviousPosition = this._previousPosition;

                locStartPosition.x = locStartPosition.x + targetX - locPreviousPosition.x;
                locStartPosition.y = locStartPosition.y + targetY - locPreviousPosition.y;
                x += locStartPosition.x;
                y += locStartPosition.y;
                locPreviousPosition.x = x;
                locPreviousPosition.y = y;
                this.target.setPosition(x, y);
            } else {
                this.target.setPosition(locStartPosition.x + x, locStartPosition.y + y);
            }
        }
    }
});